import React from 'react';
import ReactDOM from 'react-dom';

// import './style.css';


import {MainSiteComponent} from './components/MainSiteComponent';

ReactDOM.render(<MainSiteComponent state="search"/>, document.getElementById("root"));
